import R from 'ramda';
import { Observable } from 'rxjs';
import { ofTypes } from 'common/epicHelpers';
import * as applicationActions from 'application/applicationActions';
import * as submissionActions from 'submission/submissionActions';

import {
  fetchFromLocalStorage,
  saveToLocalStorage,
  removeObjectFromLocalStorage,
} from 'common/localStorageHelpers';

import {
  doesStepHaveErrors,
  getNextIncompleteStep,
  getOrganizationAlias,
  getProjectKey,
  getStep,
} from 'common/selectors';

const createStepKey = R.curry(
  (step, state) =>
    `${getProjectKey(state)}-${getOrganizationAlias(state)}-${step}`,
);

const removeStepFromLocalStorage = R.curry((step, state) =>
  removeObjectFromLocalStorage(createStepKey(step, state)),
);

export const createAcknowledgeSubmissionEpic = step => (action$, store) =>
  action$
    .ofType(submissionActions.ACKNOWLEDGE_SUBMISSION_COMPLETE)
    .mergeMap(() =>
      removeStepFromLocalStorage(step, store.getState()).map(
        submissionActions.localStorageSynced,
      ),
    );

export const createSyncLocalStorageEpic = (
  actionTypes,
  spec,
  actionCreator,
  step,
) => (action$, store) =>
  action$.filter(ofTypes(actionTypes)).debounceTime(200).mergeMap(() => {
    const state = store.getState();

    return saveToLocalStorage(
      createStepKey(step, state),
      R.applySpec(spec)(getStep(step, state)),
    )
      .map(actionCreator)
      .catch(R.pipe(applicationActions.appError, Observable.of));
  });

export const createLoadLocalStorageEpic = (step, actionCreator) => (
  action$,
  store,
) =>
  action$
    .ofType(applicationActions.APP_DATA_LOADED)
    .mergeMap(() =>
      fetchFromLocalStorage(createStepKey(step, store.getState()))
        .map(actionCreator)
        .catch(R.pipe(applicationActions.appError, Observable.of)),
    );

export const createCompleteStepEpic = (actionType, step) => (action$, store) =>
  action$.ofType(actionType).map(() => {
    const state = store.getState();

    return doesStepHaveErrors(step, state)
      ? submissionActions.showValidationErrorsDialog(true)
      : submissionActions.setActiveStep(getNextIncompleteStep(state));
  });



// WEBPACK FOOTER //
// ./src/common/stepEpicUtil.js